import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "react-toastify/dist/ReactToastify.css";
import { Config } from "../../Config";
import SupplierContent from "../../components/SupplierContent/SupplierContent";
import "./RegisterSupplier.scss";
import "./Responsive.scss";

const RegisterSupplier = (props) => {
  return (
    <section className="regWrapper">
      <Helmet>
        <title>{Config.helmetTitle} | ثبت نام نماینده</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <SupplierContent />
    </section>
  );
};

export default React.memo(RegisterSupplier);
